module.exports = __webpack_public_path__ + "img/vertical_7_6_5012.fc03887e.png";